import type { Permission } from '@/modules/auth/permissions';

/**
 * `True` if the user has all of the given permissions
 */
export const hasPermissions = (
  permissions: Permission[],
  userPermissions: string[],
) => {
  return permissions.every((permission) =>
    userPermissions.includes(permission),
  );
};

/**
 * `True` if the user has at least one of the given permissions
 */
export const hasAnyPermission = (
  permissions: Permission[],
  userPermissions: string[],
) => {
  return permissions.some((permission) => userPermissions.includes(permission));
};
